(function () {
    'use strict';

    angular.module("imApp").factory("selectNewDoctypeService", ['$ihttp', function ($ihttp) {
        let service = {
            listDocarcTypes: function (parms) {
                return $ihttp.post({
                    method: 317,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
